import { faThList } from '@fortawesome/free-solid-svg-icons';
import { faThLarge } from '@fortawesome/free-solid-svg-icons'

const dState = {
  currentAv: 1,
  currentPart: 1,
  av1: {
    p1: {
      bav: 17933940,
      title: "超可爱的动物平假名之歌！！",
      time: "2019-02-15 11:48:52",
      up: "本屋学日语",
      statics: "345播放 · 0弹幕",
      part: 1,
      pic: '动物平假名之歌.png',
      full_path: "/video/av1",
      flv: "动物平假名之歌"
    },
    p2: {
      bav: 43616016,
      title: "超可爱的动物片假名之歌！！",
      time: "2019-02-15 11:48:52",
      up: "80后佛系嬢嬢",
      statics: "345播放 · 0弹幕",
      part: 1,
      full_path: "/video/av1/?p=2",
      flv: "动物片假名之歌"
    }
  },
  av2: {
    p1: {
      bav: 17934099,
      title: "花泽香菜教你说日语五十音！耳朵真的怀孕了！",
      time: "2018-01-03 21:33:41",
      up: "本屋学日语",
      statics: "19.5万播放 · 232弹幕",
      part: 1,
      pic: "花泽香菜教你日语五十音.png",
      full_path: "/video/av2",
      flv: "花泽香菜教你日语五十音"
    },
    p2: {
      bav: 231204,
      title: "花泽香菜教你说日语五十音（加长版）",
      time: "2012-03-16 12:59:27",
      up: "夏の物语",
      statics: "28.5万播放 · 1766弹幕",
      part: 2,
      full_path: "/video/av2/?p=2",
      flv: "花泽香菜教你日语五十音（加长版）"
    }
  },
  av3: {
    p1: {
      bav: 17953444,
      title: "日本小孩都是这么学五十音的！小奶音绝了！",
      time: "2018-01-04 15:10:24",
      up: "本屋学日语",
      statics: "4.0万播放 · 160弹幕",
      part: 1,
      pic: "小奶音.png",
      full_path: "/video/av3",
      flv: "小奶音"
    }
  },
  av4: {
    p1: {
      bav: 55885211,
      title: "日语五十音记不住？唱就完事儿啦",
      time: "2019-06-17 15:55:53",
      up: "新东方在线日语",
      statics: "137播放 · 0弹幕",
      part: 1,
      pic: "日语五十音记不住？唱就完事儿啦.png",
      full_path: "/video/av4",
      flv: "日语五十音记不住？唱就完事儿啦",
    }
  },
  av5: {
    p1: {
      bav: 50379331,
      title: "日语朗读？？傲娇台词版五十音图",
      time: "2019-04-25 03:39:09",
      up: "你好小鸡",
      statics: "217播放 · 1弹幕",
      part: 1,
      pic: "日语朗读？？傲娇台词版五十音图.png",
      full_path: "/video/av5",
      flv: "日语朗读？？傲娇台词版五十音图",
    }
  },
  av6: {
    p1: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-あ-a",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6",
      flv: "handWriting/hw_a_1",
    },
    p2: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-い-i",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=2",
      flv: "handWriting/hw_i_2",
    },
    p3: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-う-u",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=3",
      flv: "handWriting/hw_u_3",
    },
    p4: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-え-e",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=4",
      flv: "handWriting/hw_e_4",
    },
    p5: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-お-o",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=5",
      flv: "handWriting/hw_o_5",
    },
    p6: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-か-ka",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=6",
      flv: "handWriting/hw_ka_6",
    },
    p7: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-き-ki",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=7",
      flv: "handWriting/hw_ki_7",
    },
    p8: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-く-ku",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=8",
      flv: "handWriting/hw_ku_8",
    },
    p9: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-け-ke",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=9",
      flv: "handWriting/hw_ke_9",
    },
    p10: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-こ-ko",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=10",
      flv: "handWriting/hw_ko_10",
    },
    p11: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-さ-sa",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=11",
      flv: "handWriting/hw_sa_11",
    },
    p12: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-し-shi",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=12",
      flv: "handWriting/hw_ko_12",
    },
    p13: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-す-su",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=13",
      flv: "handWriting/hw_ko_13",
    },
    p14: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-せ-se",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=14",
      flv: "handWriting/hw_ko_14",
    },
    p15: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-そ-so",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=15",
      flv: "handWriting/hw_ko_15",
    },
    p16: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-た-ta",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=16",
      flv: "handWriting/hw_ta_16",
    },
    p17: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ち-chi",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=17",
      flv: "handWriting/hw_chi_17",
    },
    p18: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-つ-tsu",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=18",
      flv: "handWriting/hw__18",
    },
    p19: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-て-te",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=19",
      flv: "handWriting/hw_te_19",
    },
    p20: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-と-to",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=20",
      flv: "handWriting/hw_to_20",
    },
    p21: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-な-na",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=21",
      flv: "handWriting/hw_na_21",
    },
    p22: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-に-ni",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=22",
      flv: "handWriting/hw_ni_22",
    },
    p23: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ぬ-nu",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=23",
      flv: "handWriting/hw_na_23",
    },
    p24: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ね-ne",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=24",
      flv: "handWriting/hw_ne_24",
    },
    p25: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-の-no",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=25",
      flv: "handWriting/hw_no_25",
    },
    p26: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-は-ha",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=26",
      flv: "handWriting/hw_ha_26",
    },
    p27: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ひ-hi",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=27",
      flv: "handWriting/hw_hi_27",
    },
    p28: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ふ-hu",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=28",
      flv: "handWriting/hw_hu_28",
    },
    p29: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-へ-he",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=29",
      flv: "handWriting/hw_he_29",
    },
    p30: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ほ-ho",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=30",
      flv: "handWriting/hw_ho_30",
    },
    p31: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ま-ma",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=31",
      flv: "handWriting/hw_ma_31",
    },
    p32: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-み-mi",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=32",
      flv: "handWriting/hw_mi_32",
    },
    p33: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-む-mu",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=33",
      flv: "handWriting/hw_mu_33",
    },
    p34: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-め-me",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=34",
      flv: "handWriting/hw_mi_34",
    },
    p35: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-も-mo",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=35",
      flv: "handWriting/hw_mo_35",
    },
    p36: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-や-ya",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=36",
      flv: "handWriting/hw_ya_36",
    },
    p37: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ゆ-yu",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=37",
      flv: "handWriting/hw_yu_37",
    },
    p38: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-よ-yo",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=38",
      flv: "handWriting/hw_yo_38",
    },
    p39: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ら-ra",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=39",
      flv: "handWriting/hw_ra_39",
    },
    p40: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-り-ri",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=40",
      flv: "handWriting/hw_ri_40",
    },
    p41: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-る-ru",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=41",
      flv: "handWriting/hw_ru_41",
    },
    p42: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-れ-re",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=42",
      flv: "handWriting/hw_re_42",
    },
    p43: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ろ-ro",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=43",
      flv: "handWriting/hw_ro_43",
    },
    p44: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-わ-wa",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=44",
      flv: "handWriting/hw_wa_44",
    },
    p45: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-を-wo",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=45",
      flv: "handWriting/hw_wo_45",
    },
    p46: {
      bav: 16098708,
      title: "日语五十音平假名正楷手写示范-ん-n",
      time: "2017-11-07 10:47:47",
      up: "雨宫Lin",
      statics: "11.5万播放 · 708弹幕",
      part: 1,
      pic: "handWriting.png",
      full_path: "/video/av6/?p=46",
      flv: "handWriting/hw_n_46",
    },
  }
};


export default (state = dState, action) => {
  switch (action.type) {
    case "changeVideoSelectionDisplay":
      return Object.assign({}, state, {
        videoSelectionDisplay: state.videoSelectionDisplay === "block" ? "none" : "block",
      });
    case "changeSelectionListDisplay":
      return Object.assign({}, state, {
        selectionListDisplay: state.selectionListDisplay === 'block' ? 'none' : 'block',
      });
    case "changeSelectionIcon":
      return Object.assign({}, state, {
        selectionIcon: state.selectionIcon === faThList ? faThLarge : faThList,
      });
    case "changeBarrageListStatus":
      return Object.assign({}, state, {
        barrageListStatus: state.barrageListStatus === "展开" ? "收起" : "展开",
      });
    case "changeTimeLineDisplay":
      return Object.assign({}, state, {
        timeLineDisplay: state.timeLineDisplay === "none" ? "block" : "none",
      });
    case "changeCurrentPartTo1":
      return Object.assign({}, state, {
        currentPart: 1,
      });
    case "changeCurrentPartTo2":
      return Object.assign({}, state, {
        currentPart: 2,
      });
    case "changeCurrentPart":
      return Object.assign({}, state, {
        currentPart: action.value,
      });
    case "changeCurrentAv":
      return Object.assign({}, state, {
        currentAv: action.value,
      });
    default:
      return state;
    }
}